module.exports = __webpack_public_path__ + "premium.4c620c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/premium.png
// module id = 2285
// module chunks = 0